'use client';

import { lazy, Suspense } from 'react';

const Loader2 = lazy(() => import('lucide-react').then(mod => ({ default: mod.Loader2 })));

interface SkeletonLoaderProps {
  skeletonStyle?: 'default' | 'admin';
  className?: string;
}

/**
 * Skeleton loader component for media loading states
 * Icons are lazy-loaded to reduce bundle size
 */
export function SkeletonLoader({ skeletonStyle = 'default', className = '' }: SkeletonLoaderProps) {
  if (skeletonStyle === 'admin') {
    return (
      <div className={`flex items-center justify-center w-full h-full bg-black ${className}`}>
        <Suspense fallback={<div className="w-8 h-8 bg-gray-700 rounded animate-pulse" />}>
          <Loader2 className="w-8 h-8 text-white animate-spin" />
        </Suspense>
      </div>
    );
  }
  
  // Default skeleton style
  return (
    <div className={`flex items-center justify-center w-full h-full bg-gray-200 animate-shimmer ${className}`}>
      <div className="flex flex-col items-center space-y-2">
        <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-16 h-2 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-12 h-1 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
  );
}

